export interface Point {
  x: number;
  y: number;
}

export const screenToWorld = (screen: Point, canvasPosition: Point, canvasScale: number): Point => ({
  x: (screen.x - canvasPosition.x) / canvasScale,
  y: (screen.y - canvasPosition.y) / canvasScale,
});

export const snapToGrid = (point: Point, step: number): Point => {
  if (!step || step <= 0) return point;
  return {
    x: Math.round(point.x / step) * step,
    y: Math.round(point.y / step) * step,
  };
};
